import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DrawIcon from '@mui/icons-material/Draw';
import CategoryIcon from '@mui/icons-material/Category';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BurstModeIcon from '@mui/icons-material/BurstMode';
import {
  List,
  styled,
  alpha
} from "@mui/material";
import { LinkProps } from "react-router-dom";
import ApplicationAppService from '../../application/platform/application-app-service';
import { Link, useLocation } from 'react-router-dom';
import FindInPageIcon from '@mui/icons-material/FindInPage';

import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import LinkIcon from '@mui/icons-material/Link';


interface StyledListItemButtonProps extends LinkProps {
  active?: boolean;
  component?: React.ElementType;
}

const StyledListItemButton = styled(ListItemButton)<StyledListItemButtonProps>(({ theme, active }) => ({
  borderRadius: 8,
  margin: '4px 8px',
  minHeight: 48,
  transition: 'all 0.2s ease-in-out',
  
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    transform: 'translateX(4px)',
  },
  
  ...(active && {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
    
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.16),
    }
  }),

  '& .MuiListItemIcon-root': {
    minWidth: 40,
    transition: 'color 0.2s ease-in-out',
  },

  '& .MuiListItemText-primary': {
    fontWeight: active ? 600 : 400,
    transition: 'font-weight 0.2s ease-in-out',
  }
}));

const applicationData = ApplicationAppService.getApplicationData();
const authenticationData = ApplicationAppService.getAuthenticationData();
console.log('applicationData in menu-aside:', authenticationData);
const MenuListItem = ({ to, icon, text }: { to: string; icon: React.ReactNode; text: string }) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <StyledListItemButton
      component={Link as React.ElementType}
      to={to}
      active={isActive}
    >
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText primary={text} />
    </StyledListItemButton>
  );
};

export const mainListItems = (
  <List sx={{ padding: '8px 0' }}>
    {applicationData.moduleId === 1 && (
      <>
        <MenuListItem to="/dashboard" icon={<DashboardIcon />} text="Dashboard" />
        <MenuListItem to="/envio-remessa" icon={<FileUploadIcon />} text="Envio de Remessas" />
        <MenuListItem to="/consulta-remessa" icon={<FindInPageIcon />} text="Consulta Remessa" />
      </>
    )}
    {applicationData.moduleId === 2 && (
      <>
        <MenuListItem to="/dashboard" icon={<DashboardIcon />} text="Dashboard" />
        {authenticationData?.type === 2 && (
          <MenuListItem to="/clientes" icon={<AccountBalanceIcon />} text="Clientes" />
        )}
        <MenuListItem to="/consulta-remessa" icon={<FindInPageIcon />} text="Consulta Remessa" />
        <MenuListItem to="/diagramar-diario-oficial" icon={<DrawIcon />} text="Diagramar Diário Oficial" />
        <MenuListItem to="/consulta-diario-oficial" icon={<ImageSearchIcon />} text="Consulta Diário Oficial" />
      </>
    )}
    {applicationData.moduleId === 3 && (
      <>
        <MenuListItem to="/dashboard" icon={<DashboardIcon />} text="Dashboard" />
        <MenuListItem to="/banners" icon={<BurstModeIcon />} text="Banners" />
        <MenuListItem to="/categoria-noticias" icon={<CategoryIcon />} text="Categoria de Notícias" />
        <MenuListItem to="/noticias" icon={<NewspaperIcon />} text="Notícias" />
        <MenuListItem to="/link-servicos" icon={<LinkIcon />} text="Links de Serviços" />
        <MenuListItem to="/estrutura-governamental" icon={<AccountBalanceIcon />} text="Estrutura Governamental" />
      </>
    )}
  </List>
);

export const secondaryListItems = (logout: () => void) => {
  return (
    <ListItemButton 
      onClick={logout}
      sx={{
        borderRadius: 2,
        margin: '4px 8px',
        minHeight: 48,
        '&:hover': {
          backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
          transform: 'translateX(4px)',
        },
        '& .MuiListItemIcon-root': {
          minWidth: 40,
          color: 'error.main'
        },
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <ListItemIcon>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText primary="Sair" />
    </ListItemButton>
  );
};
